/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from './auth.service';
import {MatDialog} from '@angular/material/dialog';
import { SessionUserV2Service } from './session-user.service';
import { ServiceWorkerService } from './service-worker.register.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    public authService: AuthService,
    public router: Router,
    private matDialog: MatDialog,
    private sessionUserV2Service: SessionUserV2Service,
    private swService: ServiceWorkerService
  ){ }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const origin = sessionStorage.getItem('origin');
      const params = (new URL(window.location.href)).searchParams;
      const tk = route.queryParams?.token;
      const pToken = route.queryParams?.ptoken ||  params.get("ptoken");
      const provider = route.queryParams?.provider;
      if(provider){
        sessionStorage.setItem('provider', provider);
      }  

      const loginRoute = this.authService.getRedirectLoginRoute();

      // PARAMS FOR LTI CANVAS
      const classId = route?.params?.classId;
      const districtId = route?.queryParams?.districtId;
      const schoolId = route?.queryParams?.schoolId;
      const redirectUrl = route?.queryParams?.redirectUrl;

      if(classId && districtId && redirectUrl){
          this.sessionUserV2Service.districtId = districtId;
          this.sessionUserV2Service.collectionId = classId;
          this.sessionUserV2Service.schoolId = schoolId;
          this.sessionUserV2Service.redirectUrl = redirectUrl;
          this.sessionUserV2Service.origin = 'lti';
      }
  
      if(!this.authService.isLoggedIn) {       
        const url = state.url !== '/' ? state.url : '/dashboard' ;
        const urlWithoutQueryParams = url?.split('?')?.length > 0 ? url.split('?')[0]: url;
        try {
          const classId = route.params?.classId;
          const districtId = route.queryParams?.districtId;
          const schoolId = route.queryParams?.schoolId;
          const redirectUrl = route.queryParams?.redirectUrl;

          if(url !== '/dashboard' && classId && districtId) {
            sessionStorage.setItem('lastDistrict', districtId );

            this.sessionUserV2Service.districtId = districtId;
            this.sessionUserV2Service.collectionId = classId;
            this.sessionUserV2Service.schoolId = schoolId;
            this.sessionUserV2Service.redirectUrl = redirectUrl;
            this.sessionUserV2Service.origin = origin;
          }
        } catch(e) {
          console.log(e);
        }
        if(tk) {            
            if(pToken){
               sessionStorage.setItem("pToken", pToken);
            }
            // Register after auth with custom token
            return this.authService.authWithCustomTk(tk, urlWithoutQueryParams).then(success => {
                  if (success && !this.swService.isAlreadyRegistered()) {
                    void this.swService.register();
                  }
             return success;
           });
        } else {
          void this.router.navigate([loginRoute]);
        }

      } else {
        if ( (this.authService.isLoggedIn !== true  && this.router.url !== "/trial") || origin === 'admin' ) {
          void this.router.navigate([loginRoute]);
          this.matDialog.closeAll();
          if(origin === 'admin'){ sessionStorage.clear(); }
        } else {
          const isAnonymous = this.authService.getUserFromStorage()?.email?.indexOf('demo.itopia.com') > -1 || false;
          if(isAnonymous){
              this.authService.signOut(true);
              window.location.href = "http://itopia.com/students/";
              return false;
          }
        }

        // Register Service Worker if authenticated
        if (!this.swService.isAlreadyRegistered()) {
           void this.swService.register(); // No await
        }
        return true;
      }
      return false;
  }
}
